<template>
  <div></div>
</template>

<script>
export default {
  name: 'ItemIcon',
};
</script>

<style scoped>
</style>
